import React from 'react';
import * as Icon from 'react-feather';

const navigationConfig = [
  {
    id: 'dashboard-iuli',
    title: 'dashboards',
    type: 'collapse',
    icon: <Icon.Grid size={20} />,
    children: [
      {
        id: 'dashboard',
        title: 'dashboard',
        type: 'item',
        icon: <Icon.Home size={12} />,
        navLink: '/',
        permissioniuli: 'companies.dashboards.index',
      },
      {
        id: 'sales-dashboard',
        title: 'dashboard.sales.menu',
        type: 'item',
        icon: <Icon.Activity size={12} />,
        navLink: '/sales-dashboard',
        permissioniuli: 'companies.dashboards.index',
      },
      {
        id: 'financial-dashboard',
        title: 'dashboard.financial.menu',
        type: 'item',
        icon: <Icon.BarChart2 size={12} />,
        navLink: '/financial-dashboard',
        permissioniuli: 'companies.dashboards.index',
      },
    ],
    permissioniuli: 'companies.dashboards.index',
  },
  {
    id: 'registers',
    title: 'registers',
    type: 'collapse',
    icon: <Icon.Folder size={20} />,
    children: [
      {
        id: 'bank-account-list',
        title: 'bank-account.list',
        type: 'item',
        icon: <Icon.Briefcase size={12} />,
        permissions: ['admin', 'editor'],
        navLink: '/admin/bank-account/list',
        permissioniuli: 'companies.bank-accounts.index',
      },
      {
        id: 'account-plans',
        title: 'account.plans',
        type: 'item',
        permissions: ['admin', 'editor'],
        icon: <Icon.Tag size={12} />,
        navLink: '/admin/category/list',
        permissioniuli: 'categories.tree',
      },
      {
        id: 'product-list',
        title: 'products.list',
        type: 'item',
        icon: <Icon.Box size={12} />,
        permissions: ['admin', 'editor'],
        navLink: '/admin/product/list',
        permissioniuli: 'companies.products.index',
      },
      {
        id: 'project-list',
        title: 'projects.list',
        type: 'item',
        icon: <Icon.Layers size={12} />,
        permissions: ['admin', 'editor'],
        navLink: '/admin/project/list',
        permissioniuli: 'companies.projects.index',
      },
      {
        id: 'cost-center-list',
        title: 'cost_centers.list',
        type: 'item',
        icon: <Icon.Layout size={12} />,
        permissions: ['admin', 'editor'],
        navLink: '/admin/cost-center/list',
        permissioniuli: 'companies.cost-centers.index',
      },
      {
        id: 'client-list',
        title: 'clients.list',
        type: 'item',
        icon: <Icon.User size={12} />,
        permissions: ['admin', 'editor'],
        navLink: '/admin/client/list',
        // children: ['/admin/client/edit/:company_id?'],
        permissioniuli: 'companies.clients.index',
      },
      {
        id: 'supplier-list',
        title: 'suppliers.list',
        type: 'item',
        icon: <Icon.ShoppingCart size={12} />,
        permissions: ['admin', 'editor'],
        navLink: '/admin/supplier/list',
        // children: ['/admin/supplier/edit/:company_id?'],
        permissioniuli: 'companies.suppliers.index',
      },
      {
        id: 'contract-list',
        title: 'contracts.list',
        type: 'item',
        icon: <Icon.FileText size={12} />,
        permissions: ['admin', 'editor'],
        navLink: '/admin/contract/list',
        permissioniuli: 'companies.suppliers.index',
      },
    ],
    permissioniuli: [
      'companies.bank-accounts.index',
      'categories.tree',
      'companies.products.index',
      'companies.projects.index',
      'companies.cost-centers.index',
      'companies.clients.index',
      'companies.suppliers.index',
    ],
  },
  // {
  //   id: 'sales-dashboard',
  //   title: 'dashboard.sales.menu',
  //   type: 'item',
  //   icon: <Icon.Activity size={20} />,
  //   permissions: ['admin', 'editor'],
  //   navLink: '/sales-dashboard',
  //   permissioniuli: 'companies.dashboards.index',
  // },
  // {
  //   id: 'financial-dashboard',
  //   title: 'dashboard.financial.menu',
  //   type: 'item',
  //   icon: <Icon.BarChart2 size={20} />,
  //   permissions: ['admin', 'editor'],
  //   navLink: '/financial-dashboard',
  //   permissioniuli: 'companies.dashboards.index',
  // },

  {
    id: 'dre',
    title: 'statement.dre',
    type: 'item',
    icon: <Icon.PieChart size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/dre',
    permissioniuli: 'api.statements.getDre',
    category: 1,
  },
  {
    id: 'dfc',
    title: 'statement.dfc',
    type: 'item',
    icon: <Icon.PieChart size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/dfc',
    permissioniuli: 'api.statements.getDfc',
    category: 1,
  },
  {
    id: 'detailed-statement',
    title: 'statement.detailed-statement',
    type: 'item',
    icon: <Icon.TrendingUp size={20} />,
    navLink: '/admin/statements/detailed',
    permissioniuli: 'api.statements.getDfc',
    category: 1,
  },
  {
    id: 'budget-list',
    title: 'budgets.list',
    type: 'item',
    icon: <Icon.DollarSign size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/budget/list',
    children: ['/admin/budget/edit/:budget_id?'],
    permissioniuli: 'companies.budgets.index',
    category: 1,
  }, {
    id: 'bank-reconciliation-list',
    title: 'bank-reconciliation',
    type: 'item',
    icon: <Icon.CheckSquare size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/bank-reconciliation/list',
    permissioniuli: 'api.companies.bank_accounts.import-ofx',
  },
  {
    id: 'payable-list',
    title: 'payables.list',
    type: 'item',
    icon: <Icon.ArrowDownRight size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/payable/list',
    children: ['/admin/payable/edit/:transaction_id?'],
    permissioniuli: 'companies.payables.index',
    category: 1,
  },
  {
    id: 'receivable-list',
    title: 'receivables.list',
    type: 'item',
    icon: <Icon.ArrowUpRight size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/receivable/list',
    children: ['/admin/receivable/edit/:transaction_id?'],
    permissioniuli: 'companies.receivables.index',
    category: 1,
  },
  {
    id: 'transfers.list',
    title: 'transfers.list',
    type: 'item',
    icon: <Icon.Repeat size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/transfer/list',
    children: ['/admin/transfer/edit/:transfer_id?'],
    permissioniuli: 'transfers.index',
    category: 1,
  },
  {
    id: 'product-link-list',
    title: 'product_links.list',
    type: 'item',
    icon: <Icon.Link size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/product-link/list',
    children: ['/admin/product-link/edit/:product_link_id?'],
    permissioniuli: 'api.companies.product-links.list-by-company',
    category: 1,
  },
  {
    id: 'charge-list',
    title: 'charges.list',
    type: 'item',
    icon: <Icon.Zap size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/charge/list',
    children: ['/admin/charge/edit/:charge_id?'],
    permissioniuli: 'api.companies.charges.list',
    category: 1,
    hideForIuliAdmin: true,
  },
  {
    id: 'sales-list',
    title: 'sales.list',
    type: 'item',
    icon: <Icon.CreditCard size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/sale/list',
    children: ['/admin/sale/edit/:sale_id?', '/admin/sale/import'],
    permissioniuli: 'companies.sales.index',
    category: 1,
  },
  {
    id: 'subscription-list',
    title: 'subscriptions.list',
    type: 'item',
    icon: <Icon.RefreshCcw size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/subscription/list',
    permissioniuli: 'subscription.index',
  },
  {
    id: 'invoices-download',
    title: 'invoices',
    type: 'item',
    icon: <Icon.File size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/invoice/download',
    children: ['/admin/invoice/download'],
    permissioniuli: 'invoice-downloads.index',
    category: 1,
  },
  {
    id: 'purchases-list',
    title: 'purchases.list',
    type: 'item',
    icon: <Icon.ShoppingBag size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/purchase/list',
    children: ['/admin/purchase/edit/:purchase_id?'],
    permissioniuli: 'companies.purchases.index',
    category: 1,
  },
  {
    id: 'period-closure-list',
    title: 'period_closure.list',
    type: 'item',
    icon: <Icon.Lock size={20} />,
    permissions: ['admin', 'editor'],
    navLink: '/admin/period-closure/list',
    permissioniuli: 'bank-accounts.period-closures.index',
    category: 1,
  },
  {
    id: 'stock',
    title: 'Estoque',
    type: 'item',
    icon: <Icon.Package size={20} />,
    permissions: ['admin'],
    navLink: '/admin/stock',
    permissioniuli: 'stock.index',
    category: 1,
    hideForIuliAdmin: true,
  },
  {
    id: 'support',
    title: 'support',
    type: 'item',
    icon: <Icon.Tool size={20} />,
    navLink: '/admin/support',
    permissioniuli: 'support.companies.view',
  },
];

export default navigationConfig;
